import { createContext, useContext } from 'react';
import { IChangePasswordBodyRequest, IForgotPasswordBodyRequest } from 'models/password';
import { IAuthResponse } from 'models/auth';

export interface IPasswordContext {
  changePassword: (
    body: IChangePasswordBodyRequest,
    query: any,
    successCallback: (arg: IAuthResponse) => void,
    failureCallback: (arg: string) => void,
  ) => void;
  isChangePasswordLoading: boolean;
  forgotPassword: (body: IForgotPasswordBodyRequest, successCallback?: () => void) => void;
  isForgotPasswordLoading: boolean;
}

export const PasswordContext = createContext<IPasswordContext>({} as IPasswordContext);

export const usePassword = (): IPasswordContext => useContext(PasswordContext);
